function AppInit() {
  return (
    <div
    style={{
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}
  >
    Checking authentication and initialising the application
  </div>
  );
}

export default AppInit;
